<ng-template #loading>
   <mat-spinner diameter="40"></mat-spinner>
</ng-template>

<ng-container *ngIf="userService.user | async as user else loading">
   <div style="display: flex; justify-content: center; cursor: pointer;">
      <ngx-avatar [src]="user.avatar" [value]="user.initials || user.email[0]" [round]="true" [size]="size"></ngx-avatar>
   </div>
</ng-container>
